import { createContext } from 'react'

export interface User {
  cif: string | undefined
  city: string | undefined
  code: string | undefined
  fax: string | undefined
  name: string | undefined
  province: string | undefined
  streetDescription: string | undefined
  streetName: string | undefined
  streetNumber: string | undefined
  streetType: string | undefined
  telephone: string | undefined
  zipCode: string | undefined
}

export type AuthContextProps = {
  /* user: User | undefined */
  isLogged: boolean
  logIn: () => Promise<void>
  logOut: () => Promise<void>
  storeToken: (token: string) => void
}

export const AuthContext = createContext<AuthContextProps>({} as AuthContextProps)
